import { ReactElement } from 'react';
import { AxiosResultDefaultError } from '../../../../api/request';
import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';

import { list } from '../../api';
import { Announcement } from '../../types';

interface BaseLoaderProps {
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  Announcement[],
  AxiosResultDefaultError
>();

export function useAnnouncementListLoader() {
  return useFetch();
}

export const AnnouncementListLoaderConsumer = FetchConsumer;

export default function AnnouncementListLoader({ children }: BaseLoaderProps) {
  return (
    <FetchProvider request={list} defaultQuery={undefined} fetchImmediately>
      {children}
    </FetchProvider>
  );
}
